import { useCallback, useEffect } from 'react';
import { Socket } from 'socket.io-client';
import { useSocketIoFactory } from '../sockets/useSocketIoFactory';
import { useLogoutCallback } from '../useLogoutCallback';
import Router from 'next/router';
import { ModalsKey } from '@/enums/modalsKey';
import baseAPI from '@/api';
import { LocalStorageKey } from '@/enums/localStorageKey';

export default function useUserDevicesSocket() {
  const callback = useLogoutCallback();
  const socket: Socket | null = useSocketIoFactory({
    gateway: 'user-devices',
    isProtected: true,
    extraHeaders: {
      'x-device-id':
        typeof window !== 'undefined'
          ? localStorage.getItem(LocalStorageKey.UserUUID)
          : '',
    },
  });

  const onSessionDisconnect = useCallback(async () => {
    Router.push({
      pathname: Router.pathname,
      query: Router.query,
      hash: ModalsKey.EndSession,
    });

    setTimeout(() => {
      callback();
    }, 3000);
  }, [callback]);

  function setServerOnEvents() {
    if (!socket) return;

    socket.on('disconnect-device', onSessionDisconnect);
  }

  useEffect(setServerOnEvents, [socket, onSessionDisconnect]);
}
